import { motion } from 'motion/react';
import { Sparkles } from 'lucide-react';
import { useAuthStore } from '@/lib/stores/authStore';

interface GenerateWorkoutCardProps {
  onGenerate: () => void;
  onShowAuth?: () => void;
}

export function GenerateWorkoutCard({ onGenerate, onShowAuth }: GenerateWorkoutCardProps) {
  const { isAuthenticated } = useAuthStore();

  const handleClick = () => {
    if (isAuthenticated) {
      onGenerate();
    } else {
      onShowAuth?.();
    }
  };

  return (
    <motion.button
      onClick={handleClick}
      className="w-full text-left bg-neutral-900 text-white rounded-xl p-6 hover:bg-neutral-800 transition-all"
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.98 }}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
          <Sparkles className="w-5 h-5" />
        </div>
      </div>

      <h3 className="text-2xl font-bold mb-2">
        Generate Workout
      </h3>
      
      <p className="text-white/70">
        Create a custom session tailored to your time and focus.
      </p>
    </motion.button>
  );
}

